import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-approval-matrix',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule,LoaderComponent],
  templateUrl: './approval-matrix.component.html',
  styleUrl: './approval-matrix.component.scss'
})
export class ApprovalMatrixComponent {
  isDisabled: boolean = false;
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private approvalMatrix: ApprovalMatrixService,
    protected common: CommonService,
    private tooltip : TooltipService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.GetApprovalMatrix();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  GetApprovalMatrix() {
    this.isDisabled = true;
    this.approvalMatrix.GetApprovalMatrix({ ApprovalMatrixId: 0, SelectType: 'S' }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

}
